import { numerateView } from "../../utils/functions";
import Pagination from "react-pagination-library";
import "react-pagination-library/build/css/index.css";

const PaginationC = ({ onChangeView ,defaultView, currentPage , totalPages , changeCurrentPage}) => {

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'relative', alignItems: 'center' }}>
            <select
                value={defaultView}
                onChange={ onChangeView }
            >
                {/* Mapeia o array de números para criar as opções */}
                {numerateView().map((numero) => (
                    <option key={numero} value={numero}>
                        {numero}
                    </option>
                ))}
            </select>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                changeCurrentPage={changeCurrentPage}
                theme="bottom-border"
            />
        </div>
    )
}

export default PaginationC;